import { render, staticRenderFns } from "./QuestionSectionPrint.vue?vue&type=template&id=e8a0d974&scoped=true"
import script from "./QuestionSectionPrint.vue?vue&type=script&lang=js"
export * from "./QuestionSectionPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a0d974",
  null
  
)

export default component.exports